import { defineComponent as V, ref as C, useAttrs as I, computed as p, openBlock as l, createElementBlock as d, normalizeClass as B, unref as a, createElementVNode as N, mergeProps as T, renderSlot as t, createBlock as k, createCommentVNode as u, createTextVNode as A, toDisplayString as E, createVNode as M, withCtx as z } from "vue";
import { InputSize as F, InputVariant as o, getInputLabelStyleClasses as L, getInputFieldStyleClasses as w } from "./novoui-vuejs62.js";
import D from "./novoui-vuejs12.js";
import P from "./novoui-vuejs819.js";
const _ = ["value", "placeholder", "disabled"], j = {
  key: 0,
  class: "input-label"
}, K = /* @__PURE__ */ V({
  inheritAttrs: !1,
  __name: "NSearchField",
  props: {
    size: { default: F.md },
    hasIcon: { type: Boolean, default: !0 },
    variant: { default: o.fill },
    assistiveText: {},
    errorMessage: {},
    modelValue: {},
    label: {},
    placeholder: { default: "Search" },
    invalid: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: [
    /**
     * The event emitted on input value change
     */
    "update:modelValue"
  ],
  setup(c, { expose: m, emit: f }) {
    const h = C();
    m({ inputExposed: h });
    const { class: v, ...b } = I(), S = f, g = p(() => L(s)), y = p(() => w(s.variant)), s = c, $ = (e) => {
      const r = e.target;
      S("update:modelValue", r.value);
    };
    return (e, r) => {
      var i, n;
      return l(), d("label", {
        class: B([g.value, a(v)])
      }, [
        N("input", T(b, {
          class: ["search-field", y.value],
          value: e.$props.modelValue,
          placeholder: (e.variant === a(o).fill || e.variant === a(o)["fill-light"]) && ((i = e.label) != null && i.trim() || e.$slots.label) ? "" : e.$props.placeholder,
          type: "search",
          ref: "searchExposed",
          disabled: e.$props.disabled,
          onInput: $
        }), null, 16, _),
        t(e.$slots, "iconSlot", {}, () => [
          e.hasIcon ? (l(), k(D, {
            key: 0,
            class: "input-icon search-icon",
            icon: "search"
          })) : u("", !0)
        ]),
        (n = e.label) != null && n.trim() || e.$slots.labelSlot ? (l(), d("span", j, [
          t(e.$slots, "labelSlot", {}, () => [
            A(E(e.label), 1)
          ])
        ])) : u("", !0),
        M(P, {
          assistiveText: s.assistiveText,
          errorMessage: s.errorMessage,
          invalid: s.invalid
        }, {
          default: z(() => [
            t(e.$slots, "assistiveTextSlot")
          ]),
          _: 3
        }, 8, ["assistiveText", "errorMessage", "invalid"])
      ], 2);
    };
  }
});
export {
  K as default
};
